import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import avt from "../../assets/images/user/avatar/image-01.jpg";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import HomeSharpIcon from '@mui/icons-material/HomeSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Toggle from "../../Toggle";
import useLocalStorage from "use-local-storage";

function MobileHeader({ handleMobile }) {
    const [isDark, setIsDark] = useLocalStorage("isDark", false);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const handleToggle = (key) => {
        if (toggle.key === key) {
            setToggle({
                status: false,
            });
        } else {
            setToggle({
                status: true,
                key,
            });
        }
    };
    const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    return (
        <div className="menu-mobile-popup">
            <div className="modal-menu__backdrop" onClick={handleMobile}></div>
            <div className="widget-filter">
                <div className="mobile-header">
                    <div id="logo" className="logo">
                        <Link to="/">
                            <img className="site-logo" src={logo} alt="Image" />
                        </Link>
                    </div>
                    <Link className="title-button-group" onClick={handleMobile}>
                        <i className="icon-close"></i>
                    </Link>
                </div>


                <div className="content-tab">
                    <div className="nav-wrap">
                        <nav className="main-nav mobile">
                            <ul id="menu-primary-menu" className="menu">
                                <li className="menu-item d-flex align-items-center">
                                    <HomeSharpIcon />
                                    <Link to="/joblist_v1" className="ms-2">Home</Link>
                                </li>
                                <li className="menu-item d-flex align-items-center">
                                    <WorkSharpIcon />
                                    <Link to="/employers_v1" className="ms-2">Search Job</Link>
                                </li>
                                <li className="menu-item d-flex align-items-center">
                                    <AccountCircleSharpIcon />
                                    <Link to="/employers_v1" className="ms-2">Search People</Link>
                                </li>

                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="d-flex">

                    <div className="khojPrimaryBtn ms-0">
                        <Link to="/login" className="">Login</Link>
                    </div>
                    <div className="form-group-4 ms-3">
                        <div className="khojSecondaryBtn">
                            <Link to="/register" className="">Register</Link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default MobileHeader;
